import tw from 'twin.macro';

export const outerContainer = tw`max-w-7xl mx-auto`;
